import bee from "./Bee"
export default {
    name: "Categories",
    /*
        var query = {
            number_of_categories: 1
        }

        //nyd
                //remove the following untill we have the admin being able to 
                //manage top categories module
                cats = [{
                    id: 1,
                    name: "Advertising Communications",
                    description: "",
                    icon: "mdi-television",
                    thumb_nail: "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1601464464/botswana%20services/categories/thumbnail_advertise_puqhqc.jpg",
                    is_top_category: 1,
                    top_category_level: 1,
                    belongings: [{ count: 23 }]
                }, {
                    id: 2,
                    name: "Bakery",
                    description: "",
                    icon: "mdi-baguette",
                    thumb_nail: "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1601464734/botswana%20services/categories/bakery_wcbpc4.jpg",
                    is_top_category: 1,
                    top_category_level: 2,
                    belongings: [{ count: 456 }]
                }, {
                    id: 3,
                    name: "Cabs",
                    description: "",
                    icon: "mdi-taxi",
                    thumb_nail: "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1601465139/botswana%20services/categories/cab_ywywew.jpg",
                    is_top_category: 1,
                    top_category_level: 3,
                    belongings: [{ count: 243 }]
                }, {
                    id: 4,
                    name: "Beauty Spa",
                    description: "",
                    icon: "mdi-file-cabinet", //default logo
                    thumb_nail: "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1601464734/botswana%20services/categories/bakery_wcbpc4.jpg",
                    is_top_category: 1,
                    top_category_level: 4,
                    belongings: [{ count: 89 }]
                }, {
                    id: 5,
                    name: "Education",
                    description: "",
                    icon: "mdi-book-open-page-variant-outline",
                    thumb_nail: "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1601467799/botswana%20services/categories/education_w98ifz.jpg",
                    is_top_category: 1,
                    top_category_level: 5,
                    belongings: [{ count: 56 }]
                }, {
                    id: 6,
                    name: "Argriculture",
                    description: "",
                    icon: "mdi-tractor",
                    thumb_nail: "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1601468257/botswana%20services/categories/argric_thumb_a1mfxa.png",
                    is_top_category: 1,
                    top_category_level: 6,
                    belongings: [{ count: 718 }]
                }, {
                    id: 7,
                    name: "Shopping Malls",
                    description: "",
                    icon: "mdi-cart",
                    thumb_nail: "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1601468426/botswana%20services/categories/mall_thumb_tpuium.png",
                    is_top_category: 1,
                    top_category_level: 7,
                    belongings: [{ count: 345 }]
                }];
    */
    /* eslint-disable no-unused-vars */
    get_top_categories(query, success, fail) {
        bee.get({
            categories: {
                belongings: {
                    _a: " category_id _countd_business_id ",
                    _gb: ["category_id"]
                },
                _pg: query.number_of_categories,
                _ob: ["top_category_level"],
                _w: [
                    ["is_top_category", "e", 1]
                ]
            },
        }).then(res => {
            if (success) {
                var cats = res.categories;
                success(cats);
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
    fetch_categories_page(query, success, fail) {
        // console.log(query);
        var q = {
            _julz:{
                _gets:[{
                    categories: {
                        _ob: ["name"]
                    },
                    belongings: {
                        _a: " category_id _countd_business_id ",
                        _gb: ["category_id"]
                    },
                    _indexconfig_belongings: {
                        path: "belongings.category_id",
                        key: "category_id"
                    },
                },{
                    sub_categories: {
                        _a: " category_id _count_category_id ",
                        _gb: ["category_id"]
                    },
                    _indexconfig_sub_categories: {
                        path: "sub_categories.category_id",
                        key: "category_id"
                    },
                }]
            },
            _sql: {}
        };
        bee.get(q).then(res => {
            //console.log("fetch_categories_page:", res);
            if (success) {
                success({
                    categories: res.julz.gets[0].categories,
                    belongings: res.julz.gets[0].belongings,
                    sub_categories: res.julz.gets[1].sub_categories
                });
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
    fetch_category_page(query, success, fail) {
        // console.log(query);

        var q = {
            _julz:{
                _gets:[{
                    category: {
                        _w:[
                            ["id","e",query.id]
                        ]
                    },
                    belongings: {
                        _a: " category_id _countd_business_id ",
                        _gb: ["category_id"],
                        _w:[
                            ["category_id","e",query.id]
                        ]
                    },
                    sub_categories: {
                        _a: " _count ",
                        _w:[
                            ["category_id","e",query.id]
                        ]
                    }
                },
                {
                    sub_categories: {
                        belongings: {},
                        _w:[
                            ["category_id","e",query.id]
                        ]
                    }
                },
                {
                    belongings: {
                        business: {
                            district: {}
                        },
                        _w:[
                            ["category_id","e",query.id]
                        ]
                    },
                }]
            },
            // _sql:{}
        };
        bee.get(q).then(res => {
            //console.log("fetch_category_page:", res);
            var list = [];
            var bids = [];
            for (var index = 0; index < res.julz.gets[2].belongings.length; index++) {
                var belonging = res.julz.gets[2].belongings[index];
                var temp_bid = parseInt(belonging.business_id);
                if(bids.indexOf(temp_bid) < 0){
                    bids.push(temp_bid);
                    list.push(belonging.business);
                }
            }
            if (success) {
                success({
                    category: {
                        ... res.julz.gets[0].category,
                        businesses_count: (res.julz.gets[0].belongings.length > 0)? res.julz.gets[0].belongings[0].count_business_id : 0,
                        sub_categories_count: res.julz.gets[0].sub_categories[0].count
                    },
                    sub_categories: res.julz.gets[1].sub_categories,
                    businesses: list
                });
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
    fetch_sub_category_page(query, success, fail) {
        // console.log(query);
        var q = {
            sub_category: {
                category:{},
                _w:[
                    ["id","e",query.id]
                ]
            },
            belongings: {
                business:{},
                _w:[
                    ["sub_category_id","e",query.id]
                ]
            }
        };
        bee.get(q).then(res => {
            //console.log("fetch_sub_category_page:", res);
            var list = [];
            var bids = [];
            for (var index = 0; index < res.belongings.length; index++) {
                var belonging = res.belongings[index];
                var temp_bid = parseInt(belonging.business_id);
                if(bids.indexOf(temp_bid) < 0){
                    bids.push(temp_bid);
                    list.push(belonging.business);
                }
            }
            if (success) {
                success({
                    sub_category: {
                        ... res.sub_category,
                        businesses_count: list.length
                    },
                    businesses: list
                });
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
    /*
        var query = {
            [is_admin: true],
            [is_drop_down: false]
        }
    */
    /* eslint-disable no-unused-vars */
    get_categories(query, success, fail) {
        // console.log(query);
        var q = {
            categories: {
            }
        };
        if (query.is_admin && query.is_admin == true) {
            q = {
                categories: {
                    sub_categories: {
                    },
                    belongings: {
                    }
                },
                _sql: {}
            };
        }
        if (query.is_drop_down && query.is_drop_down == true) {
            q = {
                categories: {
                    _a: "id name"
                }
            }
        }
        bee.get(q).then(res => {
            if (success) {
                success(res.categories);
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
    /*
        var query = {
            [is_admin: true],
            [is_drop_down: false]
        }
    */
    /* eslint-disable no-unused-vars */
    get_sub_categories(query, success, fail) {
        // console.log(query);
        var q = {
            sub_categories: {
            }
        };
        if (query.is_admin && query.is_admin == true) {
            q = {
                sub_categories: {
                    category: {},
                    belongings: {
                    }
                }
            };
        }
        if (query.is_drop_down && query.is_drop_down == true) {
            q = {
                sub_categories: {
                    _a: "id name"
                }
            }
        }
        bee.get(q).then(res => {
            if (success) {
                success(res.sub_categories);
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
    /*
        var query = {
            name:"";
            description:"";
            icon:this.default_icon;
            thumb_nail:this.default_thumbnail;
            is_top_category:"No";
            top_category_level:0;
        }
    */
    /* eslint-disable no-unused-vars */
    post_category(query, success, fail) {
        query.name = query.name.trim();
        //first make sure that there is no
        //category with the same top level value
        //if this submitted category is a top-category
        bee.que()
            .get({
                categories: {
                    _ntopexists: {
                        _w: [
                            [
                                ["is_top_category", "e", 1],
                                "AND",
                                ["top_category_level", "e", parseInt(query.top_category_level)]
                            ]
                        ]
                    },
                    _nnametaken: {
                        _w: [
                            ["name", "e", query.name]
                        ]
                    },
                }
            }, "unique_query")
            .post({
                category: { ...query }
            }, "new_category")
            .before("new_category", (index, previous_res, tasks) => {
                //console.log("previous_res", previous_res);
                if (previous_res.categories.ntopexists.length > 0 && parseInt(query.is_top_category) == 1) {
                    tasks[index].errors.push("Category top level " + query.top_category_level + " already occupied");
                    return false;
                } else if (previous_res.categories.nnametaken.length > 0) {
                    tasks[index].errors.push("Category by name " + query.name + " already exists");
                    return false;
                }
                return tasks[index].nectar;
            })
            .send().then(res => {
                success(res);
            }).catch(errors => {
                fail(errors);
            });
    },
    /*
        var query = {
            id: 0,
            name:"";
            description:"";
            icon:this.default_icon;
            thumb_nail:this.default_thumbnail;
            is_top_category:"No";
            top_category_level:0;
        }
    */
    /* eslint-disable no-unused-vars */
    update_category(query, success, fail) {
        query.name = query.name.trim();
        var update_query = {
            ...query,
            _w: [
                ["id", "e", query.id]
            ]
        };
        delete update_query.id; //remove the id
        //if thw name or the level is already taken then it should be this very 
        //category that has those values
        bee.que()
            .get({
                sub_categories: {
                    _w: [
                        ["name", "e", query.name]
                    ]
                },
            }, "unique_sub_query")
            .get({
                categories: {
                    _ntopexists: {
                        _w: [
                            [
                                ["is_top_category", "e", 1],
                                "AND",
                                ["top_category_level", "e", parseInt(query.top_category_level)]
                            ]
                        ]
                    },
                    _nnametaken: {
                        _w: [
                            ["name", "e", query.name]
                        ]
                    },
                }
            }, "unique_query")
            .update({
                category: update_query
            }, "update_category")
            .before("update_category", (index, previous_res, tasks) => {
                //console.log("previous_res", previous_res, tasks);

                if (previous_res.categories.ntopexists.length > 0 && parseInt(query.is_top_category) == 1) {
                    //them  it should be this category that has that value
                    var only_this_category = true;
                    var cats = previous_res.categories.ntopexists;
                    for (var i = 0; i < cats.length; i++) {
                        var cat = cats[i];
                        if (parseInt(cat.id) != parseInt(query.id)) {
                            only_this_category = false;
                        }
                    }
                    if (only_this_category == false) {
                        tasks[index].errors.push("Category top level " + query.top_category_level + " already occupied");
                        return false;
                    }
                }

                if (previous_res.categories.nnametaken.length > 0) {
                    //them  it should be this category that has that value
                    var only_this_category = true;
                    var cats = previous_res.categories.nnametaken;
                    for (var i = 0; i < cats.length; i++) {
                        var cat = cats[i];
                        if (parseInt(cat.id) != parseInt(query.id)) {
                            only_this_category = false;
                        }
                    }
                    if (only_this_category == false) {
                        tasks[index].errors.push("Category by name " + query.name + " already exists");
                        return false;
                    }
                }

                var sub_cats = tasks[0].response.sub_categories;

                if (sub_cats.length > 0) {
                    ///auto matically this cannot be cause we are upddating a category
                    tasks[0].errors.push("Category by name " + query.name + " already used by a subcategory");
                    return false;
                }

                return tasks[index].nectar;
            })
            .send().then(res => {
                success(res);
            }).catch(errors => {
                fail(errors);
            });
    },
    /*
        var query = {
            id:4,
            is_admin: true,
            is_edit: true
        }
    */
    /* eslint-disable no-unused-vars */
    get_category(query, success, fail) {
        // console.log(query);
        var q = {};
        if (query.is_admin && query.is_admin == true) {
            q = {
                category: {
                    _w: [
                        ["id", "e", query.id]
                    ]
                },
                sub_categories: {
                    _w: [
                        ["category_id", "e", query.id]
                    ]
                },
                belongings: {
                    business: {
                        user: {
                            _a: "id email first_name last_name "
                        }
                    },
                    _w: [
                        ["category_id", "e", query.id]
                    ]
                },
            };
        }
        if (query.is_edit && query.is_edit == true) {
            q = {
                category: {
                    _w: [
                        ["id", "e", query.id]
                    ]
                }
            };
        }
        bee.get(q).then(res => {
            if (success) {
                if (query.is_edit && query.is_edit == true) {
                    success(res.category);
                } else if (query.is_admin && query.is_admin == true) {
                    var temp = {
                        category: res.category,
                        sub_categories_indexes: null,
                        sub_categories: res.sub_categories,
                        businesses: []
                    };
                    for (var index = 0; index < res.sub_categories.length; index++) {
                        var sub_cat = res.sub_categories[index];
                        temp.sub_categories[index]["businesses"] = 0;
                        if (temp.sub_categories_indexes == null) {
                            temp.sub_categories_indexes = {};
                        }
                        temp.sub_categories_indexes["sub_cat_" + sub_cat.id] = index;
                    }
                    for (var index = 0; index < res.belongings.length; index++) {
                        var belonging = res.belongings[index];
                        var sub_cat_id = belonging["sub_category_id"];
                        belonging.business["sub_category_id"] = sub_cat_id;
                        belonging.business["sub_category"] = null;
                        belonging.business["category_id"] = belonging["category_id"];
                        //businesses count
                        var sub_cat_index = temp.sub_categories_indexes["sub_cat_" + sub_cat_id];
                        if (sub_cat_index > -1) {
                            temp.sub_categories[sub_cat_index]["businesses"] += 1;
                            belonging.business["sub_category"] = temp.sub_categories[sub_cat_index];
                        }
                        temp.businesses.push(belonging.business);
                    }
                    success(temp);
                }
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
    /*
    var query = {
        name:"";
        description:"";
        icon:this.default_icon;
        thumb_nail:this.default_thumbnail;
        category_id:1;
    }
*/
    /* eslint-disable no-unused-vars */
    post_sub_category(query, success, fail) {
        query.name = query.name.trim();
        //first make sure that there is no
        //sub_category with the same name
        //or category with the same name
        bee.que()
            .get({
                categories: {
                    _w: [
                        ["name", "e", query.name]
                    ]
                },
                sub_categories: {
                    _w: [
                        ["name", "e", query.name]
                    ]
                },
            }, "unique_query")
            .post({
                sub_category: { ...query }
            }, "new_sub_category")
            .before("new_sub_category", (index, previous_res, tasks) => {
                //console.log("previous_res", previous_res);
                if (previous_res.categories.length > 0 && parseInt(query.is_top_category) == 1) {
                    tasks[index].errors.push("There is a category already using this name");
                    return false;
                } else if (previous_res.sub_categories.length > 0) {
                    tasks[index].errors.push("Sub Category by name " + query.name + " already exists");
                    return false;
                }
                return tasks[index].nectar;
            })
            .send().then(res => {
                success(res);
            }).catch(errors => {
                fail(errors);
            });
    },
    /*
        var query = {
            id
        }
    */
    /* eslint-disable no-unused-vars */
    get_category_dependence(query, success, fail) {
        var query_struct = {
            _box: {
                scan_limit: 11,
                seeds: {
                    category: [query.id]
                }
            },
            _f_br: "dependence_report"
        }
        bee.get(query_struct).then(res => {
            success(res);
        }).catch(errors => {
            fail(errors);
        });
    },
    /*
        var query = {
            id: 2
        }
    */
    /* eslint-disable no-unused-vars */
    delete_category(query, success, fail) {
        var query_struct = {
            category: {
                _w: [
                    ["id", "e", query.id]
                ]
            }
        }
        bee.delete(query_struct).then(res => {
            success(res);
        }).catch(errors => {
            fail(errors);
        });
    },
    /*
        var query = {
            id:4,
            is_admin: true,
            is_edit: true
        }
    */
    /* eslint-disable no-unused-vars */
    get_sub_category(query, success, fail) {
        // console.log(query);
        var q = {};
        if (query.is_admin && query.is_admin == true) {
            q = {
                sub_category: {
                    category: {
                    },
                    _w: [
                        ["id", "e", query.id]
                    ]
                },
                belongings: {
                    business: {
                        user: {
                            _a: "id email first_name last_name "
                        }
                    },
                    _w: [
                        ["sub_category_id", "e", query.id]
                    ]
                },
            };
        }
        if (query.is_edit && query.is_edit == true) {
            q = {
                sub_category: {
                    category: {
                    },
                    _w: [
                        ["id", "e", query.id]
                    ]
                },
            };
        }
        bee.get(q).then(res => {
            if (success) {
                if (query.is_edit && query.is_edit == true) {
                    success(res.sub_category);
                } else if (query.is_admin && query.is_admin == true) {
                    var temp = {
                        sub_category: res.sub_category,
                        businesses: []
                    };
                    for (var index = 0; index < res.belongings.length; index++) {
                        var belonging = res.belongings[index];
                        temp.businesses.push(belonging.business);
                    }
                    success(temp);
                }
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
    /*
    var query = {
        id: 0,
        name:"";
        description:"";
        icon:this.default_icon;
        thumb_nail:this.default_thumbnail;
        category_id:45
    }
*/
    /* eslint-disable no-unused-vars */
    update_sub_category(query, success, fail) {
        query.name = query.name.trim();
        var update_query = {
            ...query,
            _w: [
                ["id", "e", query.id]
            ]
        };
        var id = update_query.id;
        delete update_query.id; //remove the id
        query.name = query.name.trim();
        //first make sure that there is no
        //sub_category with the same name
        //or category with the same name
        //if they exist they should be of this id
        bee.que()
            .get({
                categories: {
                    _w: [
                        ["name", "e", query.name]
                    ]
                },
                sub_categories: {
                    _w: [
                        [
                            ["name", "e", query.name],
                            "AND",
                            ["id", "ne", id]
                        ]
                    ]
                },
            }, "unique_query")
            .update({
                sub_category: update_query
            }, "edit_sub_category")
            .before("edit_sub_category", (index, previous_res, tasks) => {
                //console.log("previous_res", previous_res);
                if (previous_res.categories.length > 0) {
                    tasks[index].errors.push("There is a category already using this name");
                    return false;
                } else if (previous_res.sub_categories.length > 0) {
                    tasks[index].errors.push("Sub Category by name " + query.name + " already exists");
                    return false;
                }
                return tasks[index].nectar;
            })
            .send().then(res => {
                success(res);
            }).catch(errors => {
                fail(errors);
            });
    },
}